import { render } from "./ChatBoxMult.vue?vue&type=template&id=36a8920b&scoped=true"
import script from "./ChatBoxMult.vue?vue&type=script&lang=js"
export * from "./ChatBoxMult.vue?vue&type=script&lang=js"

import "./ChatBoxMult.vue?vue&type=style&index=0&id=36a8920b&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a8920b"]])

export default __exports__